import type { InjectionKey, Ref } from "vue";

const deactivateNavSymbol = Symbol("deactivateNav") as InjectionKey<
  Ref<boolean>
>;

export { deactivateNavSymbol };
